export const Keys = {
  ESC: `Esc`,
  ESCAPE: `Escape`,
};

export const SELECTORS = [
  {
    type: `стильный`,
    weight: 5,
  },
  {
    type: `спортивный`,
    weight: 5,
  },
  {
    type: `хозяйственный`,
    weight: 5,
  },
  {
    type: `красивый`,
    weight: 5,
  },
  {
    type: `смелый`,
    weight: 5,
  },
  {
    type: `романтичный`,
    weight: 5,
  },
];
